module.exports = __webpack_public_path__ + "static/img/大健康养老产业展厅.bd930f5d.png";